<template>
  <div class="table-container">

    <div class="header">
      <el-button type="primary" @click="handleAdd" icon="el-icon-plus">新增管理员</el-button>
    </div>

    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column prop="index" label="序号" width="80" align="center"></el-table-column>

      <el-table-column prop="name" label="角色"></el-table-column>
      <el-table-column label="权限">
        <template slot-scope="scope">
          <el-tag
              v-for="(menu, index) in scope.row.menus"
              :key="index"
              size="small"
              style="margin-right: 5px;margin-top: 5px"
          >
            {{ menu.name || menu }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="info" label="角色介绍"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
            修改
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="block">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[8,16,24,32]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="角色名" prop="name">
          <el-input v-model="form.name" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限">
          <el-checkbox v-model="form.menus" v-for="menu in menusList" :label="menu.sort"
                       :key="menu.sort">{{ menu.label }}
          </el-checkbox>
        </el-form-item>
        <el-form-item label="角色介绍" prop="name">
          <el-input v-model="form.info" placeholder="请输入角色介绍"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      menusList: [],
      currentPage: 1,
      pageSize: 8,
      total: 0,
      dialogVisible: false,
      dialogTitle: '新增角色',
      form: {
        id: '',
        name: '',
        menus: [1],
        info: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入角色名称', trigger: 'blur'}
        ],
        menus: [
          { type: 'array', min: 1, message: '请至少选择一个权限', trigger: 'change' }
        ],
        info: [
          { required: true, message: '请输入角色介绍', trigger: 'blur' }
        ]
      },
      editIndex: -1
    }
  },
  created() {
    this.fetchData();
    this.$api.findMenus().then((res) => {
      if (res.code == 200) {
        this.menusList = res.data;
      }
    })
  },
  methods: {
    fetchData() {
      this.$api.getRole({
        page: this.currentPage,
        nums: this.pageSize,
      }).then(res => {
        if (res.code == 200) {
          const mockData = res.data.list;
          this.tableData = mockData.map((item, index) => ({
            ...item,
            index: index + 1
          }));
          this.total = res.data.total;
        }
      });
    },
    handleAdd() {
      this.dialogTitle = '新增管理员权限';
      this.form = {
        id: '',
        name: '',
        menus: [1],
        info: ''
      };
      this.dialogVisible = true;
      this.editIndex = -1;
    },
    handleEdit(index, row) {
      this.dialogTitle = '修改管理员权限信息';
      this.form = {
        id: row.id,
        name: row.name,
        menus: [1],
        info: row.info
      };
      this.dialogVisible = true;
      this.editIndex = index;
    },
    handleDelete(index, row) {
      this.$confirm('确定要删除这条记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api.deleteRole({id: row.id}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.fetchData();
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.editIndex === -1) {
            // 新增
            this.$api.addMenu({
              name: this.form.name,
              info: this.form.info,
              menus: this.form.menus,
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          } else {
            // 修改
            this.$api.updateMenu({
              id: this.form.id,
              name: this.form.name,
              info: this.form.info,
              menus: this.form.menus,
            }).then(res => {
              if (res.code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.fetchData();
              }
            });
          }
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
  }
}
</script>

<style scoped>
.table-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.header {
  margin-bottom: 20px;
}

.block {
  display: flex;
  justify-content: center;
  padding-top: 15px;
  padding-bottom: 10px;
  width: 100%;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  max-width: 400px;
  height: 178px;
  display: block;
}

</style>